<template>
  <div class="rContainer">
    <dl class="bsTitleBox">
      <dt class="bsTitle">
        系统角色权限设置
      </dt>
    </dl>
    <div class="bsListBox">
      <div class="bsToolBar">
        <a-button
          type="primary"
          @click="showCreate"
        >
          新增系统角色权限
        </a-button>
      </div>
      <div
        v-if="loading"
        class="list-loading"
      >
        <img src="@assets/images/loading.gif">
        <div>正在加载...</div>
      </div>
      <div
        v-if="sysList.length"
        class="syslistBox"
      >
        <table>
          <tr>
            <th width="250">
              角色描述
            </th><th>
              权限类型
            </th><th width="180">
              权限行为
            </th><th width="100">
              操作
            </th>
          </tr>
          <tr
            v-for="(item,index) in sysList"
            :key="index"
          >
            <td class="lineTD nowrap">
              {{ item.role }}
            </td>
            <td
              colspan="3"
              class="lineTD pad0"
            >
              <table>
                <tr
                  v-for="(k,kIndex) in item.permissions"
                  :key="kIndex"
                >
                  <td>
                    {{ k.permission }}
                  </td>
                  <td width="180">
                    {{ k.action }}
                  </td>
                  <td width="100">
                    <a @click="() => handleDelete(k.permission, k.action, index)">删除</a>
                  </td>
                </tr>
              </table>
            </td>
          </tr>
        </table>
      </div>
      <div
        v-if="!loading && !sysList.length"
        class="list-empty"
      >
        <img src="@assets/images/empty.png">
        <div>咦 ~ 真的什么都没有耶…</div>
      </div>
    </div>
    <a-modal
      v-model="isCreate"
      title="新增系统角色权限"
      centered
      class="bsModalForm"
      :mask-closable="false"
      :width="514"
      @ok="handleCreate"
      @cancel="hideCreate"
    >
      <div class="sysMtext">
        角色描述
      </div>
      <div>
        <a-input
          placeholder="请输入待配置的角色"
          style="width:200px;"
          :value="applyRole"
          :class="noRole ? 'wrong' : ''"
          @focus="clearNoRole"
          @change="e => setRole(e.target.value)"
        />
      </div>

      <div class="sysMBox marT20">
        <div class="sysMtext">
          权限类型
        </div><div class="sysMtext">
          权限行为
        </div>
      </div>
      <div
        v-for="(item,index) in permissionList"
        :key="index"
        class="sysMBox"
      >
        <div>
          <a-input
            placeholder="请输入权限类型"
            style="width:200px;"
            :class="item.nopermission ? 'wrong' : ''"
            :value="item.permission"
            @focus="e => clearWarning(item.nopermission, index, 'nopermission')"
            @change="e => setFormData(e.target.value, index, 'permission')"
          />
        </div>
        <div>
          <a-input
            placeholder="请输入权限行为"
            style="width:200px;"
            :class="item.noaction ? 'wrong' : ''"
            :value="item.action"
            @focus="e => clearWarning(item.noaction, index, 'noaction')"
            @change="e => setFormData(e.target.value, index, 'action')"
          />
        </div>
        <a-icon
          v-show="permissionList.length > 1"
          class="dynamic-delete-button"
          type="minus-circle-o"
          @click="() => handleRemovePermission(index)"
        />
      </div>
      <div>
        <a-button
          style="width:420px;"
          type="dashed"
          @click="handleAddPermission"
        >
          <a-icon type="plus" /> 新增一组权限类型和权限行为
        </a-button>
      </div>
    </a-modal>
  </div>
</template>

<script>
import Vue from 'vue'
import { Button, Input, Icon, Modal, Notification, message } from 'ant-design-vue'

Vue.use(Button)
Vue.use(Input)
Vue.use(Icon)
Vue.use(Modal)

export default {
  name: 'SysPermissions',
  data() {
    return {
      sysList: [],
      loading: false,
      isCreate: false,
      applyRole: '',
      noRole: false,
      permissionList: [
        { permission: '', action: '' },
      ],
    }
  },
  created() {
    this.fetchSysList()
  },
  methods: {
    // 获取角色权限列表
    async fetchSysList() {
      this.loading = true
      try {
        const result = await this.$api.backstage.getSysList()
        // eslint-disable-next-line
        console.log('getSysList', result)
        this.$set(this, 'sysList', result)
        this.loading = false
      } catch (error) {
        const msg = error.errorMessage || error.message || '网络错误'
        message.error(msg)
      }
    },
    // 删除对应角色下的权限
    handleDelete(permission, action, index) {
      // eslint-disable-next-line
        console.log(permission, action, index, this.sysList[index].role)
      Modal.confirm({
        title: `确定要删除“${this.sysList[index].role}”角色“${permission}”的“${action}”权限吗？`,
        content: '点击确认后删除',
        icon: 'close-circle',
        class: 'deleteModal',
        centered: true,
        okText: '确定',
        cancelText: '取消',
        onOk: async () => {
          try {
            await this.$api.backstage.delSys({
              role: this.sysList[index].role,
              permission,
              action,
            })
            message.success('删除成功！')
            // 刷新列表数据
            this.fetchSysList()
          } catch (error) {
            const msg = error.errorMessage || error.message || '网络错误'
            message.error(msg)
          }
        },
      })
    },
    // 点击按钮，显示新建弹框
    showCreate() {
      this.permissionList = [ { permission: '', action: '' } ]
      this.applyRole = ''
      this.noRole = false
      this.isCreate = true
    },
    // 隐藏创建弹窗
    hideCreate() {
      this.isCreate = false
    },
    // 新增一组权限类型+权限行为
    handleAddPermission() {
      this.permissionList.push({ permission: '', action: '' },)
    },
    // 移除一组权限类型+权限行为
    handleRemovePermission(e) {
      // eslint-disable-next-line
      console.log(e)
      this.permissionList.splice(e, 1)
    },
    // 清除警告样式
    clearNoRole() {
      if (this.noRole) {
        this.noRole = false
        this.applyRole = ''
      }
    },
    clearWarning(b, index, k) {
      if (b) {
        if (k === 'nopermission') {
          delete this.permissionList[index].nopermission
          this.$set(this.permissionList[index], 'permission', '')
        }
        if (k === 'noaction') {
          delete this.permissionList[index].noaction
          this.$set(this.permissionList[index], 'action', '')
        }
      }
    },
    // 数据输入规范
    setRole(v) {
      // 过滤空格
      v = v.replace(/[ ]+/g, '')
      this.applyRole = v
    },
    setFormData(v, index, k) {
      // 过滤空格
      v = v.replace(/[ ]+/g, '')
      // 收集数据
      this.$set(this.permissionList[index], k, v)
    },
    // 创建角色权限
    async handleCreate() {
      // eslint-disable-next-line
      console.log('创建角色权限1',this.permissionList)
      const { permissionList } = this
      // 为空校验
      let haveError = false
      permissionList.forEach((item, index) => {
        if (!item.permission || item.nopermission) {
          this.$set(permissionList[index], 'nopermission', true)
          this.$set(permissionList[index], 'permission', '请输入权限类型')
          haveError = true
        }
        if (!item.action || item.noaction) {
          this.$set(permissionList[index], 'noaction', true)
          this.$set(permissionList[index], 'action', '请输入权限行为')
          haveError = true
        }
      })
      if (!this.applyRole || this.noRole) {
        this.noRole = true
        this.applyRole = '请输入待配置的角色'
        haveError = true
      }
      // 数据整理 接口校验
      if (haveError) {
        Notification.open({
          type: 'error',
          message: '未完成填写',
          description: '请注意红色提示文字。',
          style: 'background-color:#FFECE4',
        })
      } else {
        // eslint-disable-next-line
      console.log('创建角色权限2',this.permissionList)
        try {
          await this.$api.backstage.setSys({
            role: this.applyRole,
            permissions: permissionList,
          })
          message.success('创建成功！')
          // 关闭弹框
          this.isCreate = false
          // 刷新列表数据
          this.fetchSysList()
        } catch (error) {
          const msg = error.errorMessage || error.message || '网络错误'
          message.error(msg)
        }
      }
    },

  },
}
</script>

<style lang="less">
@import '~@assets/style/variables.less';
.list-loading, .list-empty{display: flex; flex-direction: column; justify-content: center; align-items: center; min-height: 234px; background-color: @white;
> img{margin-bottom: 24px;}}
.list-loading{padding: 80px;
> img{width: 160px; height: 160px;}}
.list-empty{color: #888;
> img{width: 79px; height: 108px;}}
.syslistBox{
    table{width:100%;}
    th{background: #fafafa; border-bottom: 1px solid #e8e8e8; padding: 16px;}
    td{padding: 8px 16px;}
    .lineTD{border-bottom: 1px solid #e8e8e8; }
    .pad0{padding: 0;}
    .nowrap{white-space: nowrap;}
}
.sysMtext{font-weight: 500; margin-bottom: 4px;}
.sysMBox{display: flex; align-items: center; margin-bottom: 10px;
div{ width:200px;}
div + div{margin-left: 20px;}
}
.sysMBox.marT20{margin-top: 20px; margin-bottom: 0;}
.dynamic-delete-button{margin-left:20px; font-size: 24px; color: #999; cursor: pointer;}
.dynamic-delete-button:hover{color:#777;}
</style>
